import { render, staticRenderFns } from "./personSurcharge.vue?vue&type=template&id=a2427d7c&"
import script from "./personSurcharge.vue?vue&type=script&lang=js&"
export * from "./personSurcharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2427d7c')) {
      api.createRecord('a2427d7c', component.options)
    } else {
      api.reload('a2427d7c', component.options)
    }
    module.hot.accept("./personSurcharge.vue?vue&type=template&id=a2427d7c&", function () {
      api.rerender('a2427d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4HDnQ7pWvh0SR/JS/personSurcharge.vue"
export default component.exports